import { CloseButton, Flex, forwardRef } from "@chakra-ui/react";
import RadioButtonOptionsSelect from "components/Shared/Forms/RadioButtonOptionsSelect";
import { DeliveryMethod } from "__generated__/gql/graphql";

export const deliveryMethodLabelsByType: Record<DeliveryMethod, string> = {
  [DeliveryMethod.FOB]: "FOB",
  [DeliveryMethod.DELIVERED]: "Delivered",
};

export const deliveryMethods = [
  DeliveryMethod.FOB,
  DeliveryMethod.DELIVERED,
] as const;

type Props = {
  onChange: (value: DeliveryMethod | null) => void;
  value?: DeliveryMethod | null;
};

const DeliveryMethodButtons = forwardRef<Props, "div">(
  ({ onChange, value }, ref) => (
    <Flex alignItems="center" mb={6}>
      <RadioButtonOptionsSelect
        ref={ref}
        options={deliveryMethods}
        labels={deliveryMethodLabelsByType}
        onChange={onChange}
        value={value}
        size="sm"
      />

      <CloseButton
        onClick={() => onChange?.(null)}
        size="sm"
        color="gray"
        ml={2}
      />
    </Flex>
  ),
);

export default DeliveryMethodButtons;
